import { useQuery } from '@tanstack/react-query';

import { ICatalogLimitsParams } from '@app/models/interfaces';
import Api from '@app/services/api';

export const useGetCatalogLimitsQuery = (catalogUid: string, { limit, offset }: ICatalogLimitsParams) => {
  return useQuery({
    queryKey: ['getCatalogLimits', limit, offset, catalogUid],
    queryFn: () => Api.products.getCatalogLimits(catalogUid, { limit, offset }),
    enabled: !!catalogUid,
  });
};
